import { apiClient } from '@/shared/lib/api/api-client'
import type { ConflictAction, ConflictGroup, ConflictResolution, ConflictTransaction, ConflictsSummary } from '../types/tagging'

export function fetchConflictsSummary(signal?: AbortSignal): Promise<ConflictsSummary> {
  return apiClient.get<ConflictsSummary>('/api/tagging/conflicts/summary', signal)
}

export function fetchConflictGroups(signal?: AbortSignal): Promise<ConflictGroup[]> {
  return apiClient.get<ConflictGroup[]>('/api/tagging/conflicts/groups', signal)
}

export function fetchConflictGroupTransactions(
  classifyingRuleId: number,
  contenderRuleId: number,
  signal?: AbortSignal,
): Promise<ConflictTransaction[]> {
  const query = new URLSearchParams({
    classifyingRuleId: String(classifyingRuleId),
    contenderRuleId: String(contenderRuleId),
  })
  return apiClient.get<ConflictTransaction[]>(`/api/tagging/conflicts/groups/transactions?${query.toString()}`, signal)
}

/** One decision for every open conflict between two rules. "Switch" answers how many remain: call again until none. */
export function resolveConflictGroup(
  classifyingRuleId: number,
  contenderRuleId: number,
  action: ConflictAction,
): Promise<ConflictResolution> {
  return apiClient.post<ConflictResolution>('/api/tagging/conflicts/groups/resolve', { classifyingRuleId, contenderRuleId, action })
}

export function resolveConflict(conflictId: number, action: Exclude<ConflictAction, 'Suppress'>): Promise<ConflictResolution> {
  return apiClient.post<ConflictResolution>(`/api/tagging/conflicts/${conflictId}/resolve`, { action })
}
